import React from 'react'
import { Container } from 'react-bootstrap'

const CtaOne = () => {
  return (
    <section className="h-100-v flex jcc aic cta-1">
      <Container className='tc'>
        <h3 className='title-cta c-white w-60 ma'>Ready to elevate your design experience?</h3>
        <div className="s-40"></div>
        <a href='/' className='button bg-pink c-white'>Join our waitlist today!</a>
      </Container>
    </section>
  )
}

export { CtaOne }
